module.exports = "<dl class=\"dl-horizontal m-l-md\"> <dt ng-repeat-start=\"item in $ctrl.document.specific\"><span>{{item.specificName}}</span></dt> <dd ng-repeat-end>{{item.specificValue}}</dd> </dl>";


//////////////////
// WEBPACK FOOTER
// ./src/components/document/document-specific/documentSpecificView.html
// module id = 51
// module chunks = 0